import createTopic from"../../utils/createTopic";/**
 * This topic is used to publish user notifications.
 * Examples of use include:
 *  • Display a toast;
 *  • Add a notification to the drawer.
 */const topic=createTopic('notification');export function publishNotification(options){topic.publish(options);}export const notificationTopic={subscribe:topic.subscribe,unsubscribe:topic.unsubscribe};